import { faLock } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';
import { BLEND_CHECK_MODE } from 'src/hooks/useBlendCheck';

/**
 * Why the action is disabled, rendered next to it. Nothing else on the page is
 * touched - the controls stay exactly as they were.
 */
const BlendCheckHint = ({ check, className }) => {
  if (check.mode === BLEND_CHECK_MODE.NONE || check.canProceed) {
    return null;
  }

  return (
    <div
      className={classNames('blend-hint', { 'blend-hint--blocked': check.isBlocked }, className)}
    >
      <FontAwesomeIcon icon={faLock} />
      <span>{check.isBlocked ? 'Blocked by material type' : 'Review required'}</span>
    </div>
  );
};

BlendCheckHint.propTypes = {
  check: PropTypes.shape({
    mode: PropTypes.string.isRequired,
    canProceed: PropTypes.bool.isRequired,
    isBlocked: PropTypes.bool.isRequired,
  }).isRequired,
  className: PropTypes.string,
};

BlendCheckHint.defaultProps = { className: null };

export default BlendCheckHint;
